// Libraries
import { Flex, Text } from '@chakra-ui/react';
// Components
import { FormSubmit } from '@atoms/index';
// Utils
import text from '@translations/en.json';
// Types
import { InformationFooterProps } from './InformationFooter.types';

/**
 * InformationFooter component represents the footer for the information modal.
 *
 * @component
 * @param {InformationFooterProps} props - The component props.
 * @param {string} props.message - The message to display in the information footer.
 * @param {Function} props.onClose - Callback function invoked when the modal is closed.
 * @param {Function} props.onCancel - Callback function invoked when the modal is closed but the user intends not to continue.
 * @param {Function} props.showCancelButton - A boolean flag to show or hide the cancel button.
 * @returns {ReactElement} The InformationFooter component.
 */
export const InformationFooter = ({ message, showCancelButton = false, onClose, onCancel }: InformationFooterProps) => (
  <Flex gap={4} align='center' w='full' justify='space-between' mt={5}>
    <Text fontSize='m' color='text.base' fontWeight='medium'>
      {message}
    </Text>
    {showCancelButton ? <FormSubmit
      type='button'
      fontSize='s'
      fontWeight='medium'
      shadow='md'
      width='fit-content'
      variant='outline'
      border='selected'
      backgroundColor='white'
      lineHeight={8}
      h={8}
      onClick={onCancel}
    >
      {text.try_again}
    </FormSubmit> : <></>}
    <FormSubmit
      type='button'
      fontSize='s'
      borderColor='tealishBlue'
      fontWeight='medium'
      shadow='md'
      width='fit-content'
      lineHeight={8}
      h={8}
      onClick={onClose}
    >
      {text.continue}
    </FormSubmit>
  </Flex>
);
